import './applied_date_view.js.coffee'
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedModerationDateView extends Monitoring.Views.SocialContents.Filters.AppliedDateView
  initialize: ({searchQuery}) ->
    super(searchQuery: searchQuery)
    @title = I18n.t('monitoring.dashboard.filters.filter_names.moderation_time')

  getRenderParameters: ->
    title: @title
    divId: 'moderation_date'
    date_from: @dateStrFromISO(@searchQuery.get('moderation_date_from_ISO')),
    date_to: @dateStrFromISO(@searchQuery.get('moderation_date_to_ISO')),
    date_from_realtime: @searchQuery.get('moderation_date_from_realtime')
    removable: true

  removeDateFromRealtime: =>
    @searchQuery.removeModerationDateFromRealtime()
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  removeDateFrom: =>
    @searchQuery.removeModerationDateFrom()
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)

  removeDateTo: =>
    @searchQuery.removeModerationDateTo()
    @eventAggregator.trigger('searchQueryChanged', @searchQuery)
